import Store from '../../../../store'

const authSignupRoutes = (prop) => [
  {
    path: 'error',
    name: prop + '.error',
    meta: { auth: false },
    component: () => import('../pages/ErrorPage.vue')
  },
  {
    path: 'sign-up',
    name: prop + '.sign_up',
    meta: { auth: false },
    component: () => import('../pages/Sign-up-old.vue')
  },
  {
    path: 'nothi-login-process',
    name: prop + '.nothi_login_process',
    meta: { auth: false },
    component: () => import('../pages/NothiLoginProcess.vue')
  },
  {
    path: 'forgot-password/otp-sending',
    name: prop + '.forgot_password.otp_sending',
    meta: { auth: false },
    component: () => import('../pages/ForgotPasswordOtp.vue')
  },
  {
    path: 'forgot-password/otp-verification',
    name: prop + '.forgot_password.otp_verification',
    meta: { auth: false },
    // Merged into the otp-sending page
    redirect: { name: prop + '.forgot_password.otp_sending' }
  },
  {
    path: 'forgot-password/reset-password',
    name: prop + '.forgot_password.reset_password',
    meta: { auth: false },
    props: true,
    component: () => import('../pages/ForgotPasswordResetPassword.vue')
  },
  {
    // Sign-up OTP is entered in a modal on the sign-up page now
    path: 'otp',
    name: prop + '.reg-otp',
    meta: { auth: false },
    redirect: { name: prop + '.sign_up' }
  },
  {
    path: 'sign-up-success',
    name: prop + '.sign_up_success',
    meta: { auth: false },
    component: () => import('../pages/Sign-up-success.vue')
  }
]

const authAdminRoutes = (prop) => [
  {
    path: 'role-select',
    name: prop + '.role_select',
    meta: { auth: true },
    component: () => import('../pages/RoleSelect.vue')
  },
  {
    path: 'switch-role',
    name: prop + '.switch_role',
    meta: { auth: true },
    component: () => import('../pages/SwitchRole.vue')
  },
  {
    path: 'dashboard',
    name: prop + '.dashboard',
    meta: { auth: true },
    props: true,
    component: () => import('../pages/Dashboard.vue')
  }
]

const authChildRoutes = (prop) => [
  {
    path: 'login',
    name: prop + '.login',
    meta: { auth: false },
    component: () => import('../pages/Login.vue')
  },
  {
    path: 'e-registration',
    name: prop + '.e_registration',
    meta: { auth: false },
    component: () => import('../pages/E-Registration.vue')
  }
]

const passwordChangeChildRoutes = (prop) => [
  {
    path: 'password/change',
    name: prop + '.password_change',
    meta: { auth: true },
    component: () => import('../pages/security/ChangePassword.vue')
  }
]
const secertQuestionRoutes = (prop) => [
  {
    path: 'secret-question',
    name: prop + '.secret_question',
    meta: { auth: true },
    component: () => import('../pages/secret-question/List.vue')
  }
]
const ministryRoutes = (prop) => [
  {
    path: 'dashboard/:dashboard_name',
    name: prop + '.dashboard',
    meta: { auth: true },
    component: () => import('../pages/ministry/Landing.vue')
  }
]

const routes = [
  {
    path: '/auth',
    name: 'auth',
    component: () => import('@/layouts/auth-layouts/AuthLayout'),
    meta: { auth: false },
    children: authChildRoutes('auth'),
    beforeEnter: async (to, from, next) => {
      const isLoggedIn = Store.state.Auth.authUser
      const accessToken = localStorage.getItem('access_token')

      if (isLoggedIn && isLoggedIn.office_detail && accessToken) {
          return next('/auth/dashboard')
      } else if (isLoggedIn && !isLoggedIn.office_detail && accessToken) {
          return next('/common/dashboard')
      } else {
        next()
      }
    }
  },
  {
    path: '/auth',
    name: 'authSignUp',
    component: () => import('@/layouts/auth-layouts/AuthSignupLayout'),
    meta: { auth: false },
    children: authSignupRoutes('authSignUp'),
    beforeEnter: async (to, from, next) => {
      const isLoggedIn = Store.state.Auth.authUser
      const accessToken = localStorage.getItem('access_token')

      if (isLoggedIn && isLoggedIn.office_detail && accessToken) {
          return next('/auth/dashboard')
      } else if (isLoggedIn && !isLoggedIn.office_detail && accessToken) {
          return next('/common/dashboard')
      } else {
        next()
      }
    }
  },
  {
    path: '/auth',
    name: 'authSignUp',
    component: () => import('@/layouts/auth-layouts/AuthSignupLayout'),
    meta: { auth: true },
    children: authAdminRoutes('authSignUp')
  },
  {
    path: '/ministry',
    name: 'ministry',
    component: () => import('@/layouts/MinistryUserLayout'),
    meta: { auth: false },
    children: ministryRoutes('ministry')
  },
  {
    path: '/security',
    name: 'security',
    component: () => import('@/layouts/VerticleLayout'),
    meta: { auth: true },
    children: passwordChangeChildRoutes('security')
  },
  {
    path: '/common-service/user-management',
    name: 'common_service.secret_questions',
    component: () => import('@/layouts/VerticleLayout'),
    meta: { auth: true },
    children: secertQuestionRoutes('common_service.secret_questions')
  }
]

export default routes
